import { t } from "i18next";
import { useSelector } from "react-redux";
import ButtonIcon from "../../common/buttonIcon";
import ButtonSubmit from "../../common/buttonSubmit";
import ButtonWhite from "../../common/buttonWhite";
import Moment from 'react-moment';
import moment from "moment"
import { useEffect, useState } from "react";
import TitleModal from "../../common/titleModal";
import BoxEditTimeslotInterval from "./boxEditTimeslotInterval";
import DatePickerTimeslotMultipleDate from "../../common/datePickerTimeslotMultipleDate";
import { useAppDispatch } from "../../../redux";
import { forceTimeslotUpdate, repeatTimeslots } from "../../../redux/reducer/timeslotReducer";
import ErrorMessageBox from "../../common/errorMessageBox";


const RepeatTimeslot = (props: any) => {

  let idEvent = props.idEvent ?? "";
  let showPopUpManager = props.showPopUpManager ?? "";
  const { timeTable } = useSelector((state: any) => state.timeslot);
  let event = timeTable.find((timeslot: any) => timeslot._id == idEvent);
  let startDate = moment(event?.start);
  let endDate = moment(event?.end);
  const [durationTimeslot, setDurationTimeslot] = useState(endDate.diff(startDate, 'minutes'));
  let timeslotAvailabilityDate = []
  timeslotAvailabilityDate[timeslotAvailabilityDate.length] = { startTime: "", endTime: "" }
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [timeslotAvailability, setTimeslotAvailability] = useState(timeslotAvailabilityDate);
  const dispacth = useAppDispatch()
  let dataArray: any = [];
  const [dateSelect, setDateSelect] = useState(dataArray);
  const [errorMessage, setErrorMessage] = useState("");
  const deleteTimeslot = () => {
    console.log("Delete", idEvent);
  }

  useEffect(() => {
    if (event) {
      let timeslotAvailabilityDate = []
      timeslotAvailabilityDate[timeslotAvailabilityDate.length] = { startTime: "", endTime: "" }
      setTimeslotAvailability(timeslotAvailabilityDate);
      setDateSelect([event?.start]);
      let startDate = moment(event?.start);
      let endDate = moment(event?.end);
      setDurationTimeslot(endDate.diff(startDate, 'minutes'));
    }
  }, [event]);

  const addTimeslotAvailability = () => {
    let array: any = Object.assign([], timeslotAvailability);
    array[timeslotAvailability.length] = { startTime: "", endTime: "" };
    setTimeslotAvailability(array);
  }
  const removeTimeslotAvailability = (id: number) => {
    let array: any = Object.assign([], timeslotAvailability);
    setTimeslotAvailability(array.filter((value: any, index: number) => index !== id));
  }
  const mangerEditTimeslotInterval = (value: any, id: any) => {
    if (id == (timeslotAvailability.length - 1)) {
      addTimeslotAvailability()
    }
    else {
      removeTimeslotAvailability(id)
    }
  }

  const repeatTimeslot = async () => {
    setErrorMessage("");
    let object: any = {};
    object.timeslotCategoryId = event?.categoryId;
    object.timeslotDuration = durationTimeslot;
    object.timezone = timezone;
    object.timeslotInterval = "";
    object.maximumAttendances = event?.maximumAttendances;
    object.repeatDays = dateSelect.map((date: any) => moment(date).format("YYYY-MM-DD"));

    let timeslotAvailabilityNotEmpty = timeslotAvailability.filter((availability: any) => (availability.startTime !== "" || availability.endTime !== ""));

    if (!timeslotAvailabilityNotEmpty.length) {
      setErrorMessage(t('error.empty-timeslot-availability'));
      return
    }
    object.timeslotAvailabilityTimetables = timeslotAvailabilityNotEmpty;
    const result = await dispacth(repeatTimeslots(object));
    if (result.status == 200) {
      props.changeMessagesuccess(result.data.status)
      props.closePopUp();
      dispacth(forceTimeslotUpdate())

    }
    else {
      setErrorMessage(result.data?.error ?? t('error.generic'));
      console.log("Data Error", result.data?.error);
    }
    console.log("Repeat Click: ", result);

  }
  return (
    <>
      <div className={`RepeatTimeslot ModalTimeslot ViewTimeslot ${((showPopUpManager == "Repeat") ? 'active' : '')}`}>
        <div className="header">
          <div className="row ">
            <div className="col-10">
              <h6>{t('popup-timeslot-repeat.label-repeat') as String}</h6>
              <h6><b><Moment format="LL">{event?.start}</Moment>  </b></h6>
              <h6><Moment format="HH:mm">{event?.start}</Moment> - <Moment format="HH:mm">{event?.end}</Moment></h6>
            </div>
            <div className="col-2 text-right">
              <ButtonIcon handleClick={props.closePopUp} icon="close" />
            </div>
          </div>
        </div>
        <div className="body">
          <TitleModal title={t('popup-timeslot-repeat.label-interval', { durationTimeslot })} />
          <BoxEditTimeslotInterval handelClick={mangerEditTimeslotInterval} timeslotAvailability={timeslotAvailability} />
          <TitleModal title={t('label-select-day-service')} />
          <DatePickerTimeslotMultipleDate date={dateSelect} handleChange={(setDateSelect)} />
          <ErrorMessageBox errorMessage={errorMessage} />
        </div>
        <div className="footer">
          <div className="row">
            <div className="col-lg-12 text-lg-right p-2">
              <ButtonWhite handleChange={props.closePopUp} textButton={t('cancel')} />
              <ButtonSubmit handleChange={repeatTimeslot} textButton={t('repeat')} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RepeatTimeslot